import styled from 'styled-components';
import React from 'react';
import DynamicImage from '../../../atoms/DynamicImage/index';
import colors from '../../../../helpers/colors';

const Container = styled.div`
    background: ${colors.mvLightestGrey};
    padding: 100px;
    margin-bottom: 130px;

    @media (max-width: 500px) {
        margin: 0 auto;
    }
`;

const HeadingText = styled.p`
    color: ${colors.mvDarkGrey};
    margin-bottom: 20px;
    font-size: 30px;
    font-weight: 900;
    line-height: 45px;
    text-align: center;
`;

const FeaturedResources = styled.div`
    margin-top: 29px;
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 0px 50px;

    @media (max-width: 900px) {
        padding: 0 20px;
    }
    @media screen and (max-width: 769px) {
        flex-direction: row;
        flex-wrap: wrap;
    }
    @media (max-width: 500px) {
        flex-direction: column;
        padding: 0;
        align-items: center;
        margin: 0 auto;
    }
`;

const FeaturedResource = styled.a`
    margin-bottom: 40px;
    cursor: pointer;
    text-decoration: none;
    background-color: ${colors.mvWhite};
    box-shadow: 0px 4px 7px ${colors.greyBoxShadow};
    width: 262px;
    height: 307px;
    padding: 18px;
    border-radius: 10px;
    transition: .4s;
    margin: 0 30px;
    

    &:hover {
        box-shadow: 0px 4px 7px ${colors.darkGreyBoxShadow};
        transition: .4s;
    }

    @media (max-width: 769px) {
        margin: 0 20px 40px 20px;
    
    @media (max-width: 500px) {
        padding-bottom: 100px;
        margin-bottom: 35px;
    }
`;

const ResourceType = styled.p`
    padding: 20px 0 10px 0;
    font-size: 16px;
    font-weight: bold;
    color: ${colors.mvBlue};
`;

const ResourceTitle = styled.p`
    font-size: 17px;
    font-weight: bold;
    color: ${colors.mvMediumGrey};
`;

const RelatedSection = ({
    relatedContent
}) => {
    return (
        <Container>
            <HeadingText>Also worth checking out:</HeadingText>
            <FeaturedResources>
                {relatedContent ? 
                    relatedContent.map(resource => {
                        const { type, title, image, imageAlt, link } = resource;

                        return (
                            <FeaturedResource href={link + '/'} key={title} >  
                                <DynamicImage src={image} alt={imageAlt} />

                                <ResourceType>{type}</ResourceType>
                                <ResourceTitle>{title}</ResourceTitle>
                            </FeaturedResource>
                        );
                    }): null
                }
                
            </FeaturedResources>
        </Container>
    );
};

export default RelatedSection;
